import { render, staticRenderFns } from "./TankMonitor.vue?vue&type=template&id=475c7efe"
import script from "./TankMonitor.vue?vue&type=script&lang=js"
export * from "./TankMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports